export default {
  section: {
    general: 'Allgemein',
    data: 'Eingangsdaten',
    limits: 'Grenzen',
  },
};
